// extracted by mini-css-extract-plugin
module.exports = {"tnc-wrapper":"Bi3iQdPdp_ym0UcZAUAUv"};